import { render, staticRenderFns } from "./CompProfileEditChildrenSupport.vue?vue&type=template&id=58c1c6b6&scoped=true"
import script from "./CompProfileEditChildrenSupport.vue?vue&type=script&setup=true&lang=js"
export * from "./CompProfileEditChildrenSupport.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c1c6b6",
  null
  
)

export default component.exports